import React from 'react';
import {
    Routes,
    Route,
    useNavigate,
    Navigate,
    useLocation
} from 'react-router-dom';
import { FaStethoscope, FaProcedures, FaNotesMedical } from 'react-icons/fa';
import ComplexetyLevel from './ComplexetyLevel';
import PrincipalCID from './PrincipalCID';
import Procedures from './Procedures';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Nível de Complexidade',
        path: '/governanceroom/dashboardsiasus/stratification/complexety-level',
        icon: <FaStethoscope style={{ marginRight: '5px' }} />
    },
    {
        title: 'Procedimentos',
        path: '/governanceroom/dashboardsiasus/stratification/procedures',
        icon: <FaProcedures style={{ marginRight: '5px' }} />
    },
    {
        title: 'CID Principal',
        path: '/governanceroom/dashboardsiasus/stratification/principal-cid',
        icon: <FaNotesMedical style={{ marginRight: '5px' }} />
    }
];

const titlesMap = {
    '/governanceroom/dashboardsiasus/stratification/complexety-level':
        'Nível de Complexidade do Procedimento',
    '/governanceroom/dashboardsiasus/stratification/procedures':
        'Procedimentos',
    '/governanceroom/dashboardsiasus/stratification/principal-cid':
        'CID Principal'
};

const Stratification = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsiasus');
    };

    return (
        <div className="estratificacao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titlesMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="complexety-level"
                            element={
                                <ComplexetyLevel
                                    module={{
                                        sectionTitle: 'do Total de Atendimentos'
                                    }}
                                    queryConfig={{
                                        key: 'complexity-level-services',
                                        url: 'governanceroom/dashboard/services/stratify/complexity'
                                    }}
                                />
                            }
                        />
                        <Route path="procedures" element={<Procedures />} />
                        <Route
                            path="principal-cid"
                            element={<PrincipalCID />}
                        />
                        <Route
                            path="/"
                            element={<Navigate to="complexety-level" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};

export default Stratification;
